var map = {
	"./Monk.png": "e14c0",
	"./defaultcharacter.png": "cdc4",
	"./female/Barbarian.png": "6067",
	"./female/Bard.png": "e80f",
	"./female/Cleric.png": "c87a",
	"./female/Druid.png": "9365",
	"./female/Monk.png": "f165",
	"./female/Paladin.png": "d239",
	"./female/Ranger.png": "311c",
	"./female/Rogue.png": "bd16",
	"./female/Wizard.png": "b71c",
	"./img/Barbarian.png": "5e83",
	"./img/Bard.png": "2ac8",
	"./img/Cleric.png": "663d",
	"./img/Druid.png": "7058",
	"./img/Monk.png": "38ee",
	"./img/Paladin.png": "04df",
	"./img/Ranger.png": "1844",
	"./img/Rogue.png": "19ad",
	"./img/Wizard.png": "edf8",
	"./img/female/Barbarian.png": "fa34",
	"./img/female/Bard.png": "704f",
	"./img/female/Cleric.png": "e2af",
	"./img/female/Druid.png": "3d3e",
	"./img/female/Monk.png": "55ea",
	"./img/female/Paladin.png": "b905",
	"./img/female/Ranger.png": "d927",
	"./img/female/Rogue.png": "99b2",
	"./img/female/Wizard.png": "7c72",
	"./img/full/female/barbarian.png": "9032",
	"./img/full/female/bard.png": "68ff",
	"./img/full/female/cleric.png": "83f7",
	"./img/full/female/druid.png": "4e11",
	"./img/full/female/monk.png": "f2e9",
	"./img/full/female/paladin.png": "2085",
	"./img/full/female/ranger.png": "9d0f",
	"./img/full/female/rogue.png": "756a",
	"./img/full/female/wizard.png": "2ef4",
	"./img/full/male/barbarian.png": "9374",
	"./img/full/male/bard.png": "b5d2",
	"./img/full/male/cleric.png": "e14c",
	"./img/full/male/druid.png": "ed05",
	"./img/full/male/monk.png": "7af1",
	"./img/full/male/paladin.png": "c535",
	"./img/full/male/ranger.png": "3e90",
	"./img/full/male/rogue.png": "2436",
	"./img/full/male/wizard.png": "b7d5",
	"./img/male/Barbarian.png": "5ffa",
	"./img/male/Bard.png": "7c25",
	"./img/male/Cleric.png": "6c58",
	"./img/male/Druid.png": "0f45",
	"./img/male/Monk.png": "205c",
	"./img/male/Paladin.png": "77dc",
	"./img/male/Ranger.png": "177b",
	"./img/male/Rogue.png": "90e8",
	"./img/male/Wizard.png": "24ff",
	"./male/Barbarian.png": "3ee6",
	"./male/Bard.png": "76b6",
	"./male/Cleric.png": "3cc0",
	"./male/Druid.png": "3d88",
	"./male/Monk.png": "bd6c",
	"./male/Paladin.png": "0326",
	"./male/Ranger.png": "03a3",
	"./male/Rogue.png": "2628",
	"./male/Wizard.png": "77f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15a5";